module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (116).6ae8f144.jpg";